export default "__VITE_ASSET__BHTz6Yel__"